import { ARCHIVE_CONTENT_FOLDERS_SUCCESS } from "fleet/redux-store/content-folders/actions";
import { ARCHIVE_CONTENT_GROUPS_SUCCESS } from "fleet/redux-store/content-groups/actions";
import { mediaLibraryService } from "fleet/service/media-library";
import get from "lodash/get";
import { all, put, call, takeLatest } from "redux-saga/effects";
import { createApiAction } from "redux-store/api-sagas";
import { addMessageAction, LEVEL_ERROR } from "redux-store/messages";
import { ARCHIVE_USER_CONTENTS_SUCCESS } from "redux-store/user-contents/actions";
import { getErrorMessage } from "util/response";

import {
  MEDIA_LIBRARY_ARCHIVE,
  MEDIA_LIBRARY_ARCHIVE_ERROR,
  MEDIA_LIBRARY_ARCHIVE_SUCCESS,
} from "./actions";

function getSuccessEffect(actionType, data, successMessage = "") {
  return put(createApiAction(actionType, data, 200, successMessage));
}

function archiveSuccessActions(data = {}, successMessage = "") {
  // API returns this data in a singular form: pluralize for readability
  let {
    content: contents = [],
    content_group: contentGroups = [],
    folder: folders = [],
  } = data;

  // Archiving a folder must update all of its contents so we should add them
  // to the action payload
  folders.forEach((f) => {
    contents = contents.concat(f.contents);
    contentGroups = contentGroups.concat(f.content_groups);
  });

  return [
    getSuccessEffect(MEDIA_LIBRARY_ARCHIVE_SUCCESS, data, successMessage),
    ...(folders.length
      ? [getSuccessEffect(ARCHIVE_CONTENT_FOLDERS_SUCCESS, folders)]
      : []),
    ...(contentGroups.length
      ? [getSuccessEffect(ARCHIVE_CONTENT_GROUPS_SUCCESS, contentGroups)]
      : []),
    ...(contents.length
      ? [getSuccessEffect(ARCHIVE_USER_CONTENTS_SUCCESS, contents)]
      : []),
  ];
}

function* mediaLibraryArchive(action) {
  const serviceName = "MediaLibraryService.archive";
  let response;
  try {
    const serviceArgs = get(action, "payload.serviceArgs", []);
    response = yield call(mediaLibraryService.archive, ...serviceArgs);
  } catch (e) {
    console.error(`${serviceName} responded`, e.status);

    const errMsg = getErrorMessage(e);
    yield all([
      put(createApiAction(MEDIA_LIBRARY_ARCHIVE_ERROR, {}, e.status, errMsg)),
      put(addMessageAction(LEVEL_ERROR, errMsg, serviceName, e.status)),
    ]);
    return;
  }

  const successMessage = get(action, "payload.successMessage", "");
  yield all(archiveSuccessActions(response.data, successMessage));
}

function* mediaLibraryArchiveSaga(action) {
  yield takeLatest(MEDIA_LIBRARY_ARCHIVE, mediaLibraryArchive);
}

const mediaLibrarySagas = [mediaLibraryArchiveSaga()];

export { mediaLibrarySagas };
